import { render, staticRenderFns } from "./StickyBar.vue?vue&type=template&id=3dab24b2&scoped=true&"
import script from "./StickyBar.vue?vue&type=script&lang=js&"
export * from "./StickyBar.vue?vue&type=script&lang=js&"
import style0 from "./StickyBar.vue?vue&type=style&index=0&id=3dab24b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab24b2",
  null
  
)

export default component.exports